import { useAuthStore } from '@/store/auth.store';

export const useAuth = () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    error,
    mustChangePassword,
    login,
    register,
    logout,
    fetchUser,
    clearError,
    clearMustChangePassword,
  } = useAuthStore();

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    mustChangePassword,
    login,
    register,
    logout,
    fetchUser,
    clearError,
    clearMustChangePassword,
  };
};

